import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../Button/index.js';
import { Link } from 'react-router-dom';
import { Wrapper } from '../Wrapper/index.js';
import styles from 'ui-components/AppFooter.scss';

var AppFooter = function AppFooter(_ref) {
  var SubscribeToNewsletter = _ref.SubscribeToNewsletter,
    contentStayInTouch = _ref.contentStayInTouch,
    contentBranding = _ref.contentBranding,
    contentCustom = _ref.contentCustom,
    contentTerms = _ref.contentTerms,
    categories = _ref.categories,
    activeLinks = _ref.activeLinks,
    _ref$hasVisibleHelpCo = _ref.hasVisibleHelpColumn,
    hasVisibleHelpColumn = _ref$hasVisibleHelpCo === void 0 ? false : _ref$hasVisibleHelpCo,
    useUi = _ref.useUi,
    MODE = _ref.MODE;
  var t = useTranslate();
  var _useUi = useUi(),
    setHamburgerOpen = _useUi.setHamburgerOpen,
    setSubNavOpen = _useUi.setSubNavOpen,
    setViewMode = _useUi.setViewMode;
  var links = function links() {
    return /*#__PURE__*/React__default.createElement("nav", {
      className: styles.nav
    }, activeLinks && activeLinks.includes("start") && /*#__PURE__*/React__default.createElement(Link, {
      className: styles.link,
      to: "/"
    }, t("FOOTER.LINKS.START")), activeLinks && activeLinks.includes("categories") && /*#__PURE__*/React__default.createElement(Button, {
      className: cn("link", styles.link),
      onClick: function onClick() {
        setHamburgerOpen(true);
        setSubNavOpen(true);
        setViewMode(MODE.CATEGORIES);
      }
    }, t("FOOTER.LINKS.CATEGORIES")), activeLinks && activeLinks.includes("brands") && /*#__PURE__*/React__default.createElement(Button, {
      className: cn("link", styles.link),
      onClick: function onClick() {
        setHamburgerOpen(true);
        setSubNavOpen(true);
        setViewMode(MODE.BRANDS);
      }
    }, t("FOOTER.LINKS.BRANDS")), activeLinks && activeLinks.includes("search") && /*#__PURE__*/React__default.createElement(Button, {
      className: cn("link", styles.link),
      onClick: function onClick() {
        setHamburgerOpen(true);
        setSubNavOpen(true);
        setViewMode(MODE.SEARCH);
      }
    }, t("FOOTER.LINKS.SEARCH")));
  };
  return /*#__PURE__*/React__default.createElement("footer", {
    className: styles.footer
  }, /*#__PURE__*/React__default.createElement(Wrapper, {
    className: styles.wrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.cols
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__links)
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: styles.heading
  }, t("FOOTER.LINKS.TITLE")), links()), contentCustom !== null && contentCustom !== undefined && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__custom)
  }, contentCustom()), categories && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__categories)
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: styles.heading
  }, t("FOOTER.LINKS.CATEGORIES")), /*#__PURE__*/React__default.createElement(CategoryList, {
    categories: categories
  })), hasVisibleHelpColumn && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__needHelp)
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: styles.heading
  }, t("FOOTER.NEED_HELP.TITLE")), /*#__PURE__*/React__default.createElement("nav", {
    className: styles.nav
  }, /*#__PURE__*/React__default.createElement(Link, {
    className: styles.link,
    to: t("CUSTOMER_SERVICE.LINK")
  }, t("FOOTER.NEED_HELP.CONTACT")))), contentStayInTouch !== null && contentStayInTouch !== undefined && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__stayInTouch)
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: styles.heading
  }, t("FOOTER.STAY_IN_TOUCH.TITLE")), contentStayInTouch()), contentBranding !== null && contentBranding !== undefined && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.col, styles.col__branding)
  }, contentBranding()), SubscribeToNewsletter)), contentTerms && /*#__PURE__*/React__default.createElement(Wrapper, {
    className: cn(styles.wrapper, styles.bottomField)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.contentTerms
  }, contentTerms())));
};
var CategoryList = function CategoryList(_ref2) {
  var categories = _ref2.categories;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.categories
  }, categories.map(function (x) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: x.name,
      className: styles.category
    }, /*#__PURE__*/React__default.createElement(Link, {
      className: styles.categoryLink,
      to: {
        pathname: x.url,
        state: {
          hint: {
            type: "category",
            category: x
          }
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, x.name)));
  }));
};

export { AppFooter };
//# sourceMappingURL=index.js.map
